import * as Yup from 'yup';
import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import closeFill from '@iconify/icons-eva/close-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
// material
import {
  Link,
  Stack,
  Alert,
  Checkbox,
  TextField,
  IconButton,
  InputAdornment,
  FormControlLabel
} from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
// routes
import { PATH_AUTH, PATH_DASHBOARD, PUBLIC } from '../../../routes/paths';
// hooks
import useAuth from '../../../hooks/useAuth';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
//
import { MIconButton } from '../../@material-extend';
import { useTheme } from '@material-ui/core/styles';
// ----------------------------------------------------------------------

export default function LoginForm() {
  const navigate = useNavigate()
  const { login } = useAuth();
  const isMountedRef = useIsMountedRef();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme();
  const LoginSchema = Yup.object().shape({
    username: Yup.string().required('username is required'),
    password: Yup.string().required('Password is required')
  });

  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
      remember: true
    },
    validationSchema: LoginSchema,
    onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {
      try {
        const result = await login(values.username, values.password);

        if (result?.requires2FA) {
          sessionStorage.setItem('2fa_pending_token', result.pendingToken || '');
          sessionStorage.setItem('2fa_email', result.email || '');
          enqueueSnackbar(result.message || 'OTP sent to your email', {
            variant: 'success',
            action: (key) => (
              <MIconButton size="small" onClick={() => closeSnackbar(key)}>
                <Icon icon={closeFill} />
              </MIconButton>
            )
          });
          navigate(PATH_AUTH.loginOtp, { replace: true });
          return;
        }

        if (!result?.accessToken) {
          setSubmitting(false);
          setErrors({ afterSubmit: result?.message || 'Login failed' });
          return;
        }

        enqueueSnackbar('Login success', {
          variant: 'success',
          action: (key) => (
            <MIconButton size="small" onClick={() => closeSnackbar(key)}>
              <Icon icon={closeFill} />
            </MIconButton>
          )
        });
        navigate(PATH_DASHBOARD.root, { replace: true })
        // if (isMountedRef.current) {
        //   setSubmitting(false);
           
        // }
      } catch (error) {
        console.error(error);
        resetForm();
        if (isMountedRef.current) {
          console.log("HHHHHHHHHHHHHH", error.message);
          setSubmitting(false);
          setErrors({ afterSubmit: "Invalid Email Id or Password" });
        }
      }
    }
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
            {errors.afterSubmit && <Alert severity="error">{errors.afterSubmit}</Alert>}

            <TextField
              fullWidth
              autoComplete="username"
              type="text"
              label="Username"
              {...getFieldProps('username')}
              error={Boolean(touched.username && errors.username)}
              helperText={touched.username && errors.username}
              sx={{
                '& input:-webkit-autofill': {
                  boxShadow: theme.palette.mode === 'light' ? '0 0 0 1000px #fff inset' : '0 0 0 1000px #161c24 inset',   // ✅ white background
                  WebkitTextFillColor: theme.palette.mode === 'light' ? '#000' : '#fff',           // ✅ black text
                  caretColor: theme.palette.mode === 'light' ? '#000' : '#fff'
                }
              }}
            />

            <TextField
              fullWidth
              autoComplete="current-password"
              type={showPassword ? 'text' : 'password'}
              label="Password"
              {...getFieldProps('password')}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleShowPassword} edge="end">
                      <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              error={Boolean(touched.password && errors.password)}
              helperText={touched.password && errors.password}
              sx={{
                '& input:-webkit-autofill': {
                  boxShadow: theme.palette.mode === 'light' ? '0 0 0 1000px #fff inset' : '0 0 0 1000px #161c24 inset',   // ✅ white background
                  WebkitTextFillColor: theme.palette.mode === 'light' ? '#000' : '#fff',           // ✅ black text
                  caretColor: theme.palette.mode === 'light' ? '#000' : '#fff'
                }
              }}
            />
          </Stack>

        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
          <FormControlLabel
            control={<Checkbox {...getFieldProps('remember')} checked={values.remember} />}
            label="Remember me"
          />

          <Link component={RouterLink} variant="subtitle2" to={PATH_AUTH.resetPassword}>
            Forgot password?
          </Link>
        </Stack>

        <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
          Login
        </LoadingButton>
        <Link sx={{marginTop:8}} component={RouterLink} variant="subtitle2" to={PUBLIC.root}>
        Privacy And Policy
        </Link>
      </Form>
    </FormikProvider>
  );
}
